import React from 'react';
import { Footprints, Play } from 'lucide-react';

export const ContinueWalkingBanner = ({ 
  savedWalkingSession, 
  onContinue 
}) => {
  if (!savedWalkingSession) return null;

  return (
    <button
      onClick={onContinue}
      className="w-full mb-4 p-4 bg-gradient-to-r from-blue-500/10 to-cyan-500/10 border-2 border-blue-500/30 rounded-3xl hover:border-blue-400/50 transition-all group"
      data-testid="continue-walking-btn"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-2xl flex items-center justify-center shadow-lg shadow-blue-500/30">
            <Footprints className="w-6 h-6 text-white animate-pulse" />
          </div>
          <div className="text-left">
            <h3 className="text-white font-heading font-bold group-hover:text-blue-400 transition-colors">
              Continue Walking
            </h3>
            <p className="text-slate-400 text-sm">
              {savedWalkingSession.sessionSteps > 0 
                ? `${savedWalkingSession.sessionSteps.toLocaleString()} steps • ${Math.floor(savedWalkingSession.totalElapsedTime / 60)}min elapsed`
                : 'Resume your walking session'
              }
            </p>
          </div>
        </div>
        <div className="w-10 h-10 bg-blue-500/20 rounded-full flex items-center justify-center group-hover:bg-blue-500/30 transition-colors">
          <Play className="w-5 h-5 text-blue-400" />
        </div>
      </div>
    </button>
  );
};

export default ContinueWalkingBanner;
